export default function getDeviceLocale() {
    return navigator.language;
}
